import postFetcher from 'api/utils/postFetcher';
import { useCallback } from 'react';
import type { RouterCredentials } from 'types/legacyDashboard';

interface UseGenerateRouterCredentialsProps {
  deviceId?: DeviceId;
  organizationId?: OrgId;
}

interface GenerateRouterCredentialsReturn {
  data: RouterCredentials;
  success: boolean;
}

const useGenerateRouterCredentials = ({
  deviceId,
  organizationId,
}: UseGenerateRouterCredentialsProps) => {
  const queryParams = new URLSearchParams({ orgid: `${organizationId}` });
  const url = `${process.env.VITE_API_ROOT}/csr/sources?${queryParams}`;

  const callback = useCallback(async () => {
    if (!organizationId) {
      return undefined;
    }
    const result: GenerateRouterCredentialsReturn | undefined = await postFetcher({
      url,
      body: { deviceid: deviceId ?? [] },
    });

    return result;
  }, [deviceId, organizationId, url]);

  return callback;
};

export default useGenerateRouterCredentials;
